jQuery(() => {
  /**
  * Update itens count on click in +/- symbols
  */
  document.querySelectorAll('.cart-qty').forEach(qtyButton => qtyButton.addEventListener('click', function (event) {
    event.preventDefault()
    let action, productId, qtyId
    productId = this.href.split('#')[1]
    action = this.dataset.action
    qtyId = `qty${productId}`
    if (action === 'inc') {
      document.getElementById(qtyId).value++
    } else {
      document.getElementById(qtyId).value--
    }
    document.getElementById('form-shop-cart').submit()
  }))

  /**
   * Shrink shipping summary text between parentheses
   */
  let aux, cell
  cell = document.querySelector('.totals tbody tr:not(:first-of-type) td')
  if (cell) {
    aux = cell.innerHTML.split('(')
    aux[2] = aux[2] ? `(${aux[2]}` : ''
    aux = `${aux[0]}<small>(${aux[1]}${aux[2]}</small>`
    cell.innerHTML = aux
  }
})
